<template>
  <div class="md:py-2 md:px-3 group flex-y-center gap-2">
    <div class="w-full">
      <p
        class="text-gray-450 text-base font-semibold leading-130"
        :class="descriptionClass"
      >
        {{ description }}
      </p>
      <p
        class="!text-base md:!text-xl !font-semibold !font-interDisplay !text-dark-300 !leading-130"
        :class="{ 'group-last:!text-green': course }"
      >
        <slot :name="type">
          {{ title }}
        </slot>
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  title?: string;
  description: string;
  type: string;
  course?: boolean;
  image?: boolean;
  descriptionClass?: string;
}

withDefaults(defineProps<Props>(), {
  title: "-",
  description: "-",
});
</script>
